module.exports = __webpack_public_path__ + "ad0b2176132ba090b7abb847b7eeea28.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/GT-Sectra-Fine-Medium.ttf
// module id = 47
// module chunks = 0